import { Report } from 'notiflix/build/notiflix-report-aio'
import { Loading } from 'notiflix'
import axios from 'axios'
import { browserName, osName } from 'react-device-detect'
import { trackCompleteRegistration, trackLead } from './handleTracking'

// Increment these when form wording or consent text changes materially
const FORM_VERSION = '1.1'
const CONSENT_WORDING_VERSION = '1.1'

interface uploadInterface {
    id: string
    files: any
}

export const uploadDataToServer = async (claimObject: any) => {
    console.log('Uploading DATA. ')
    Loading.standard('Uploading DATA.')

    // Build the lead payload from an explicit allow-list of the fields the backend lead schema
    // accepts. The shared claim object accumulates fields from every step (including signature
    // checkboxes and previous-address editing), and the lead endpoint rejects unknown keys, so we
    // must not blindly spread the whole claim.
    const toBool = (value: unknown) => value === 'yes' || value === true

    const payload = {
        title: claimObject.title,
        firstname: claimObject.firstname,
        lastname: claimObject.lastname,
        dob: claimObject.dob,
        telephone: claimObject.telephone,
        email: claimObject.email,
        address_line_one: claimObject.address_line_one,
        address_line_two: claimObject.address_line_two,
        address_line_three: claimObject.address_line_three,
        city: claimObject.city,
        county: claimObject.county,
        postcode: claimObject.postcode,
        leadOrigin: claimObject.leadOrigin,
        leadSource: claimObject.leadSource,
        previous_addresses: claimObject.previous_addresses,
        consentToContactAboutThisClaim: toBool(claimObject.consentToContactAboutThisClaim),
        sms_opt_in: toBool(claimObject.sms_opt_in),
        phone_opt_in: toBool(claimObject.phone_opt_in),
        email_opt_in: toBool(claimObject.email_opt_in),
        whatsapp_opt_in: toBool(claimObject.whatsapp_opt_in),
        sentinel_referral_consent: toBool(claimObject.sentinel_referral_consent),
        form_version: FORM_VERSION,
        consent_wording_version_id: CONSENT_WORDING_VERSION,
    }

    try {
        const response = await axios({
            method: 'post',
            url: `${process.env.REACT_APP_API_UPLOAD_DATA_URL}`,
            data: payload,
        })

        trackLead({ email: claimObject.email, phone: claimObject.phone })

        console.log('DATA UPLOAD RESPONSE: ', response.data)
        Loading.remove()
        return response.data
    } catch (error: any) {
        console.log('ERROR IS : ', error)
        Loading.remove()

        const status = error?.response?.status
        const data = error?.response?.data

        if (data === 'Lead is duplicate') {
            Report.info('No Additional Claims', 'We have previously received your details and are progressing the case.', 'Thank you', () => {
                window.location.href = 'https://sentinellegal.co.uk'
            })
        } else if (status === 400 && data?.message) {
            // Validation failure — show the specific, user-friendly reason the
            // backend returned (e.g. "Please enter a valid UK postcode.").
            Report.failure('Please check your details', data.message, 'Okay')
        } else {
            Report.failure('Error Occurred', 'Please refresh the page and try again.', 'okay')
        }

        return { success: false }
    }
}

export const uploadFileToServer = async (id: string, files: any, idUploadOrigin: string) => {
    Loading.standard('Uploading files...')
    const formData = new FormData()

    let isID = false
    formData.append('id', id)

    files.forEach((fileToAttach: any) => {
        formData.append(fileToAttach.fileInputName, fileToAttach.file)
        if (fileToAttach.fileInputName == 'poid') {
            isID = true
            formData.append('type', idUploadOrigin)
        }
    })

    try {
        const response = await axios({
            method: 'post',
            url: `${process.env.REACT_APP_API_UPLOAD_FILES_URL}`,
            data: formData,
            headers: { 'Content-Type': 'multipart/form-data' },
        })
        console.log('FILE UPLOAD RESPONSE: ', response.data)
        if (isID) trackCompleteRegistration()

        Loading.remove()
        console.log('RESPONSE : ', response)

        return response?.data
    } catch (error: any) {
        Loading.remove()

        if (!error.response) {
            console.log('ERROR IS : ', error)
            if (error.message === 'No file provided') {
                Report.failure('No file selected', 'Please add a file and try again.', 'okay')
            } else {
                Report.failure('Error Ocurred', 'Please refresh the page and try again.', 'okay')
            }
        } else {
            const errorMessage = error.response.data.error.message
            if (errorMessage === 'Token not found') {
                Report.failure('Broken Link Used', 'Please click the link found in your "CFA signed" email to upload your ID.', 'okay')
            } else if (errorMessage === 'Extension not accepted') {
                Report.failure('Incorrect file type', 'Please check the file type and try again.', 'okay')
            } else if (errorMessage === 'File exceeds 20MB') {
                Report.failure('File exceeds 20MB', 'Please use a smaller image and try again.', 'okay')
            } else if (errorMessage === 'Couldnt convert image.') {
                Report.failure('Use different Image', 'Please use a standard image format (PNG, JPEG, HEIC)', 'okay')
            } else {
                Report.failure('Error Ocurred', 'Please refresh the page and try again.', 'okay')
            }
        }

        return { success: false }
    }
}
